import React from "react";
import { Sidebar } from "primereact/sidebar";
import { Accordion, AccordionTab } from "primereact/accordion";
import Pricelinedemo from "../../../public/img/helpVideos/Pricelinedemo.mov";
import PBH_HelpVideo_v3_240423 from "../../../public/img/helpVideos/PBH_HelpVideo_v3_240423.mp4";
import { Button } from "primereact/button";
const HelpSidebar = (props) => {
  //going to have to add to this with every page, can't figure out a way to do a dynamic import depending on our HelpData.json

  let specificPageHelpData = props.helpData && props.helpData.length > 0;

  let mapOver = specificPageHelpData
    ? props.helpData
    : Object.values(props.helpData);

  return (
    <Sidebar
      position="right"
      visible={props.helpVisible}
      onHide={() => props.toggleHelpVisible(false)}
    >
      {mapOver.map((helpData, idx) => {
        console.log("helpData", helpData);
        let video =
          helpData.videoLink == "Pricelinedemo"
            ? Pricelinedemo
            : helpData.videoLink == "PBH_HelpVideo_v3_240423"
            ? PBH_HelpVideo_v3_240423
            : "none";

        return (
          <div>
            <div
              style={{
                color: "var(--color-white)",
                background: "var(--jetstream-purple)",
                padding: "7px",
                paddingBottom: "1px",
                marginBottom: "4px",
              }}
            >
              <h2>
                {helpData.page} Page{" "}
                {!specificPageHelpData &&
                  helpData.audience &&
                  `- ${helpData.audience}`}
              </h2>
            </div>
            {helpData.videoLink && (
              <div>
                <video //
                  //id="helpVideo"
                  id={idx}
                  controls
                  width="280"
                  onClick={() => {
                    alert("click");
                  }}
                >
                  <source src={video} type="video/webm"></source>
                </video>
              </div>
            )}
            <Accordion multiple>
              {helpData &&
                helpData.content.map((contentArr, i) => {
                  return (
                    <AccordionTab header={helpData.titles[i]}>
                      <div>
                        <p>
                          {contentArr.map((textObj) => {
                            //inherited line height looks a bit cramped
                            return textObj.type == "header" ? (
                              <h4
                                style={{
                                  lineHeight: "initial",
                                  background: "aliceblue",
                                }}
                              >
                                {textObj.text}
                              </h4>
                            ) : (
                              <p style={{ lineHeight: "initial" }}>
                                {textObj.text}
                              </p>
                            );
                          })}
                        </p>
                        {helpData.videoSkips &&
                          helpData.videoSkips.length > 0 &&
                          helpData.videoSkips[i] && (
                            <Button
                              aria-label="HelpSidebar-Button-OpenVideoSection"
                              icon="fas fa-forward"
                              label="Open video section"
                              onClick={() => {
                                let myVideo = document.getElementById(idx);

                                myVideo.currentTime =
                                  helpData.videoSkips[i];
                                myVideo
                                  .requestPictureInPicture()
                                  .catch((error) => {
                                    console.log("error", error);
                                  });
                                myVideo.play();
                              }}
                            />
                          )}
                      </div>
                    </AccordionTab>
                  );
                })}
            </Accordion>{" "}
          </div>
        );
      })}
    </Sidebar>
  );
};

export default HelpSidebar;
